import { useQuery } from "@apollo/client";
import { FC } from "react";
import { useRecoilValue } from "recoil";
import Carousel from "~/components/Carousel";
import Container from "~/components/Container";
import ProductItem from "~/components/Items/ProductItem";
import SectionTitle from "~/components/SectionTitle";
import ProductItemSkeleton from "~/components/Skeletons/ProductItemSkeleton";
import Text from "~/components/Text";
import { QUERY_GET_OPTIMISTIC_RECOMMEND_PRODUCT_GQL } from "~/data/gallery-product/gql";
import useCountdown from "~/hooks/useCountdown";
import OrderAtom from "~/services/order/order.atom";
import { transformProductItems } from "~/utils/transform";
import styles from "./OfferProducts.module.scss";

interface OfferProductsProps {}

const OfferProducts: FC<OfferProductsProps> = () => {
  const [countdown] = useCountdown();
  const order = useRecoilValue(OrderAtom.order);
  const { data, loading } = useQuery(
    QUERY_GET_OPTIMISTIC_RECOMMEND_PRODUCT_GQL,
    {
      variables: {
        skus: order.items?.map((i) => i.product.sku),
      },
    }
  );
  const products = transformProductItems(data?.Recommend?.items);

  return (
    <Container>
      <div className="flex flex-col gap-3 pt-10 lg:pt-16 pb-10">
        <SectionTitle text="You May Also Like" centered />
        <div className={styles.offer}>
          <Text type="body-2" className="text-center">
            Offer will expire in{" "}
            <Text htmlTag="span" type="title-4" className="text-primary">
              {countdown}
            </Text>
          </Text>
        </div>
        <Carousel
          slidesToScroll={2}
          slidesToShow={4}
          infinite={products?.length > 4}
          centerMode={false}
          responsive={[
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
          ]}
        >
          {loading &&
            Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className={"!px-3 lg:!px-5"}>
                <ProductItemSkeleton />
              </div>
            ))}
          {products?.map((item) => (
            <div key={item.id} className={"!px-3 lg:!px-5"}>
              <ProductItem data={item} />
            </div>
          ))}
        </Carousel>
      </div>
    </Container>
  );
};

export default OfferProducts;
